import React from 'react';
import Imgix, { SharedImigixAndSourceProps } from 'react-imgix';

import useImgix from './useImgix';

type ImgixSizes = Omit<SharedImigixAndSourceProps, 'width' | 'height'> & {
  sizes: string;
};

type ImgixWidth = Omit<SharedImigixAndSourceProps, 'sizes'> & {
  width: number;
};

const ImgixWrapper: React.FC<ImgixSizes | ImgixWidth> = props => {
  const { transformImageURL } = useImgix();
  return (
    <Imgix
      htmlAttributes={{ 'data-test-locator': 'imgix' }}
      {...props}
      src={transformImageURL(props.src)}
    />
  );
};

export default ImgixWrapper;
